import { jsPDF } from 'jspdf'
import type { ContactSubmission } from '../types'

export function exportToPDF(
  submissions: ContactSubmission[],
  status: 'unread' | 'read' | 'responded' | 'all'
) {
  const doc = new jsPDF()

  // Title
  doc.setFontSize(18)
  doc.setFont('helvetica', 'bold')
  doc.text('Roosevelt Cheer - Contact Submissions', 14, 20)

  // Subtitle
  doc.setFontSize(12)
  doc.setFont('helvetica', 'normal')
  const statusText =
    status === 'all'
      ? 'All Submissions'
      : `${status.charAt(0).toUpperCase()}${status.slice(1)} Submissions`
  doc.text(statusText, 14, 28)
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 14, 34)

  // Submissions
  let yPos = 45

  submissions.forEach((submission, index) => {
    // Check if we need a new page
    if (yPos > 260) {
      doc.addPage()
      yPos = 20
    }

    // Submission number
    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text(`#${index + 1}`, 14, yPos)

    // Name and date
    doc.setFont('helvetica', 'bold')
    doc.text(submission.name, 25, yPos)
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(9)
    const date = new Date(submission.created_at * 1000).toLocaleDateString()
    doc.text(date, 160, yPos)

    yPos += 6

    // Email and phone
    doc.setFontSize(9)
    doc.text(`Email: ${submission.email}`, 25, yPos)
    if (submission.phone) {
      yPos += 5
      doc.text(`Phone: ${submission.phone}`, 25, yPos)
    }

    yPos += 5

    // Status
    doc.text(`Status: ${submission.status}`, 25, yPos)

    yPos += 6

    // Message
    doc.setFont('helvetica', 'italic')
    doc.text('Message:', 25, yPos)
    yPos += 5

    doc.setFont('helvetica', 'normal')
    const messageLines = doc.splitTextToSize(submission.message, 160)
    doc.text(messageLines, 25, yPos)

    yPos += messageLines.length * 5 + 8

    // Separator
    doc.setDrawColor(217, 220, 224) // coolgray
    doc.line(14, yPos, 196, yPos)
    yPos += 8
  })

  // Save the PDF
  const filename = `contact-submissions-${status}-${new Date().toISOString().split('T')[0]}.pdf`
  doc.save(filename)
}
